<template>
  <div class="comparison-tip" :class="{ 'show-close': showClose }" v-show="show">
    <icon v-if="icon" class="tip-icon" :icon="icon" size="sm" />
    <span class="tip-message">
      <slot name="message" />
    </span>
    <div v-if="showClose" class="close-tip" @click="show = false">
      <icon icon="times-solid" size="sm" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Icon from '../icon/Icon.vue';
const show = ref(true);

const { props } = defineProps({
  icon: String,
  showClose: {
    type: Boolean,
    default: true,
  }
});

</script>

<style lang="scss">
@use 'assets/scss/all.scss' as *;

.comparison-tip {
  @include flex-row-start;

  font-size: 15px;
  position: relative;

  border: 1px solid $all-green-50;
  background-color: $all-green-10;

  background-color: #AEF7A9;
  color: $text-positive;
  
  background-color: #AEF7A9;
  color: #085f33;

  color: #0a710a;
  background: #C5F6C5;
  border: 1px solid #0a710a;
  // border-radius: 10px;

  padding: 12px 16px 12px 16px;

  border-left-width: 0;
  border-right-width: 0;
  font-weight: 500;
  line-height: 22px;

  @include breakpoint-up(lg) {
    border-radius: 15px;
    border-left-width: 1px;
    border-right-width: 1px;
  }

  &.show-close {
    padding: 12px 32px 12px 16px;
  }

  .tip-icon {
    align-self: flex-start;
    margin-right: 12px;
    background-color: currentColor;

    align-self: center;
  }

  &.no-icon {
    @include breakpoint-down(lg) {
      .tip-icon {

        display: none;
      }
    }
  }

  a,
  .text-link {
    white-space: nowrap;
    font-weight: bold;
    cursor: pointer;
    text-decoration: underline;
    transition: color 0.15s;
    color: $link-base-default;

    &:hover {
      color: $link-base-hover;
    }
  }



  .link-element {
    margin-top: 8px;
    font-size: 15px;
    color: $all-green-100;
    cursor: pointer;

    &:hover {
      color: $all-green-50;
    }
  }

  .light-bold {
    white-space: nowrap;
  }

  .close-tip {
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    cursor: pointer;

    .icon-element {
      background-color: $all-green-100;
    }
  }

  &.warning {
    background-color: $all-orange-10;
    border-color: $all-orange-80;
    color: $text-base;

    .close-tip .icon-element,
    .tip-icon {
      background-color: $all-orange-80;
    }

  }
}
</style>
